import React from "react";
import SectionTable from "./SectionTable";
import { useBanner } from "../../../../providers/BannerProviders";
import useFetch from "../../../../hooks/useFetch";
import { publicationList } from "../../../../services/publicationService";
import { categoryList } from "../../../../services/catagoryService";

const Publications = () => {
  const { data: vpetersData } = useBanner();
  const vpetersBanner = vpetersData?.data?.find(
    (item) => item?.bannerType === "v'Peters"
  );

  const { data, error, isLoading, updateData, isFetching, refetch } = useFetch({
    dependencies: ["front-publicationList"],
    fetchFunction: async () => {
      const res = await publicationList({
        limit: 100,
        status: 1,
      });
      return res?.docs;
    },
  });

  const {
    data: categoryData,
    error: categoryError,
    isLoading: categoryIsLoading,
    updateData: categoryUpdateData,
    isFetching: categoryIsFetching,
    refetch: categoryRefetch,
  } = useFetch({
    dependencies: ["font-categoryList"],
    fetchFunction: async () => {
      const res = await categoryList({
        type: "publication",
        status: 1,
      });
      return res?.docs;
    },
  });

  const reportData = categoryData?.data.map((item) => {
    return {
      title: item?.name,
      subdata: data?.data
        .filter((data) => data?.categoryType === item?._id)
        .map((item) => ({
          title: item?.title,
          size: +(item?.image?.size / (1024 * 1024)).toFixed(2) + " MB",
          action: { label: "Download PDF", link: item?.image?.url },
        })),
    };
  });

  return (
    <>
      {data?.data && Array.isArray(data?.data) && data?.data?.length > 0 && (
        <section className="relative flex w-full pt-11 pb-0 xls:py-24 bg-white">
          <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4">
            <div className="space-y-1 xls:space-y-10">
              <div className="space-y-6 max-w-4xl mx-auto">
                {vpetersBanner?.details?.publication?.title && (
                  <h2 className="text-3xl sm:text-4xl xls:text-[42px] font-bold text-center">
                    {vpetersBanner?.details?.publication?.title}
                  </h2>
                )}
                {vpetersBanner?.details?.publication?.description && (
                  <h3
                    className="text-center text-base xls:text-lg font-Gotham xls:font-medium"
                    dangerouslySetInnerHTML={{
                      __html: vpetersBanner?.details?.publication?.description,
                    }}
                  />
                )}
              </div>
              {reportData?.length > 0 && (
                <div className="">
                  {reportData?.map((item, index) => (
                    <SectionTable key={index} data={item} />
                  ))}
                </div>
              )}
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default Publications;
